<template>
    <div>
        <div class="container-block" style="margin:15px 0;">
            <a-form-model layout="inline">
                <a-form-model-item label="计划期间">
                    <a-input style="width:200px" placeholder="期间" @pressEnter="getList()" v-model="search.rangeName" />
                </a-form-model-item>
                <a-form-model-item label="是否有效">
                    <a-select v-model="search.isEffective" style="width: 200px;" placeholder="请选择">
                        <a-select-option :value="1">是</a-select-option>
                        <a-select-option :value="0">否</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="创建日期">
                    <a-range-picker valueFormat="YYYY-MM-DD" v-model="search.createTime" />
                </a-form-model-item>
                <a-form-model-item>
                    <a-space>
                        <a-button type="primary" @click="getList()">查询</a-button>
                        <a-button @click="resetList">清空</a-button>
                    </a-space>
                </a-form-model-item>
            </a-form-model>
        </div>
        <div class="container-block" style="padding-bottom:0">
            <a-table :columns="columns" :loading="tableLoading" :data-source="list.records"
                :row-key="record => record.id" :pagination="pagination" @change="onTableChange">
                <span slot="isPush" slot-scope="text" :style="{ color: text == 0 ? 'red' : 'green' }">
                    {{ text == 0 ? '否' : '是' }}
                </span>
                <span slot="testFormulaType" slot-scope="text">
                    {{ text == '1' ? '测算配方' : '执行配方' }}
                </span>
                <template slot="options" slot-scope="text, record">
                    <a @click="viewDetail(record)">查看</a>
                </template>
            </a-table>
        </div>

        <range-detail :visible="detailModalVisible" :monthId="detailObj.id"
            @close="detailModalVisible = false"></range-detail>
    </div>
</template>

<script>
import RangeDetail from './modal/RangeDetail.vue';
import { tableMixins } from '@/Utils/tableMixins.js';
const columns = [
    {
        title: '版本号',
        dataIndex: 'pushVersion',
        align: 'center',
        ellipsis: true,
        width: 200
    },
    {
        title: '计划期间',
        dataIndex: 'rangeName',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '实体组织编码',
        dataIndex: 'companyOrgCode',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '是否有效',
        dataIndex: 'isEffective',
        align: 'center',
        scopedSlots: { customRender: 'isPush' }
    },
    {
        title: '截止时间',
        dataIndex: 'notifyEndTime',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '是否推送',
        dataIndex: 'isPush',
        align: 'center',
        scopedSlots: { customRender: 'isPush' }
    },
    {
        title: '推送时间',
        dataIndex: 'pushTime',
        align: 'center',
        ellipsis: true,
    },
    {
        title: '创建时间',
        align: 'center',
        dataIndex: 'createTime',
        ellipsis: true,
    },
    {
        title: '操作',
        dataIndex: 'options',
        width: 180,
        align: 'center',
        scopedSlots: { customRender: 'options' }
    },
];

export default {
    components: { RangeDetail },
    mixins: [tableMixins],
    data() {
        return {
            columns,
            tableLoading: false,
            list: {
                records: []
            },
            search: {},

            detailObj: {},
            detailModalVisible: false
        };
    },
    mounted() { 
        this.getFactoryDetails();
    },
    watch: {
        '$route'() {
            this.getList();
        },
    },
    methods: {
        getFactoryDetails() {
            const id = window.localStorage.getItem("factoryId");
            this.$get('/iot-factory/factory/detail', { id }).then(res => {
                let { success, data } = res || {};
                if (success) {
                    this.factoryCode = data.ebsEntityCode;
                    // 存一个工厂的详细信息
                    window.localStorage.setItem('factoryDetail', JSON.stringify(data));
                    this.getList();
                }
            });
        },
        async getList(pagination) {
            let { current, pageSize } = pagination || this.pagination;
            let param = {
                companyOrgCode: this.factoryCode,
                current: current,
                size: pageSize,
                ...this.search
            };
            if (this.search.createTime) {
                const [start, end] = this.search.createTime;
                param = { ...param, createStTime: `${start} 00:00:00`, createEndTime: `${end} 23:59:59` };
                delete param.createTime;
            }

            await this.$http.get("/nhf-value-estimate/api/friday/calculate/month", { params: param }).then(res => {
                let { data, success, msg } = res || {};
                if (success) {
                    let { records, total = 0, current = 1, size } = data || {};
                    this.list.records = records;
                    this.setPagination({ total, current, size });
                } else {
                    this.$message.error(msg);
                }
            });
        },

        resetList() {
            this.search = {};
            this.getList();
        },

        onTableChange(pagination) {
            this.getList(pagination);
        },

        viewDetail(row) {
            this.detailObj = row;
            this.detailModalVisible = true;
        }
    }
};
</script>
<style scoped>
.disabled {
    color: #888;
}

.list-item {
    font-size: 12px;
}

.dropdown-list {
    max-height: 300px;
    width: 240px;
    overflow: auto;
    margin: -10px;
}
</style>